import React from 'react';
import "./judgmentsList.css"
import JudgmentsData from './judgmentsData';

const JudgmentsList = (props) => {
    return ( 
        <>
            <div className="mainJudgmentsList">
                <h1 className="judgmentsTitle">Lista wyroków</h1>
                <JudgmentsData 
                    judgmentsList={props.judgmentsList}
                    handleDeleteJudgment={props.handleDeleteJudgment}
                />
            </div>
        </>
     );
}
 
export default JudgmentsList;